module.exports = __webpack_public_path__ + "img/national-qualification-level-5.5a393727.jpg";